import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../services/query-client';

interface QueryProviderProps {
  children: React.ReactNode;
}

const QueryProvider: React.FC<QueryProviderProps> = ({ children }) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};

export default QueryProvider;
